module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"subtitle":"Alle Food Trucks nach Region – heute geöffnete stehen oben.","title":"Unsere Trucks"},"en":{"subtitle":"All food trucks by region – the ones open today come first.","title":"Our trucks"}}')
  delete Component.options._Ctor
}
